import { Injectable, inject } from '@angular/core';

import type { Observable } from 'rxjs';

import { HttpApiService } from '@core/http-legacy';
import { ReportDashboardTemplatesResponse } from '@core/reports-types';

@Injectable({ providedIn: 'root' })
export class ReportsDashboardTemplatesHttpClient {
  protected readonly httpApi = inject(HttpApiService);

  // TODO: shared analytics change endpoint without /report after backend update
  public fetchCollection(): Observable<ReportDashboardTemplatesResponse> {
    return this.httpApi.get('report/templates/dashboards');
  }
}
